import React from 'react';

/**
 * The one line at the foot of every page: where the privacy page lives (lmsbe backlog item 48).
 *
 * A button rather than an `<a href>`, because there is no router - a href would be a full page
 * load, and `?page=privacy` already covers anybody arriving from outside. The address is on the
 * page itself, not here, so it is written down in one place.
 */
function SiteFooter({ onNavigate }) {
  return (
    <footer className="site-footer">
      <span>Gaffer Picks</span>
      <span aria-hidden="true">·</span>
      <button type="button" className="site-footer-link" onClick={() => onNavigate('privacy')}>
        Privacy
      </button>
    </footer>
  );
}

export default SiteFooter;
